/**
 * Returns the value as a string for display, or an em dash when the value is
 * absent (null, undefined, or empty string). A zero is a real value and is kept.
 */
export function displayOrDash(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  return String(value);
}
